// extracted by mini-css-extract-plugin
export default {"list":"ingredients-category_list__w0Vdi"};